export default {
	home: {
		title: 'Home'
	}
}
